<template>
  <VaLayout v-if="breakpoint.lgUp" class="h-screen bg-[var(--va-background-secondary)]">
    <template #left>
      <RouterLink
        class="auth-hero h-full flex items-center justify-center"
        style="width: 35vw"
        to="/"
        aria-label="Visit homepage"
      >
        <div class="logo-badge">
          <VuesticLogo :height="200" />
        </div>
      </RouterLink>
    </template>
    <template #content>
      <main class="h-full flex items-center justify-center mx-auto max-w-[420px]">
        <RouterView />
      </main>
    </template>
  </VaLayout>

  <VaLayout v-else class="h-screen bg-[var(--va-background-secondary)]">
    <template #content>
      <div class="auth-mobile">
        <div class="auth-hero-mobile">
          <div class="auth-hero-mobile__content">
            <RouterLink class="py-4" to="/" aria-label="Visit homepage">
              <div class="logo-badge logo-badge--mobile mb-2">
                <VuesticLogo :height="92" />
              </div>
            </RouterLink>
          </div>
        </div>
        <div class="auth-mobile__content p-4">
          <main class="flex flex-row items-start justify-start mx-auto max-w-[420px]">
            <div class="flex flex-col items-start">
              <RouterView />
            </div>
          </main>
        </div>
      </div>
    </template>
  </VaLayout>
</template>

<script lang="ts" setup>
import { useBreakpoint } from 'vuestic-ui'
import VuesticLogo from '../components/VuesticLogo.vue'

const breakpoint = useBreakpoint()
</script>

<style lang="scss" scoped>
// White circular badge so the logo reads clearly against the dark hero image.
.logo-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 300px;
  height: 300px;
  border-radius: 9999px;
  background: #ffffff;
  box-shadow: 0 18px 45px rgba(2, 6, 23, 0.3);
}

.logo-badge--mobile {
  width: 140px;
  height: 140px;
  box-shadow: 0 10px 24px rgba(2, 6, 23, 0.28);
}

.auth-hero {
  position: relative;
  background-image: url('/login_bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.auth-hero::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(2, 6, 23, 0.65) 0%, rgba(2, 6, 23, 0.35) 100%);
}

.auth-hero > * {
  position: relative;
  z-index: 1;
}

.auth-hero-mobile {
  position: relative;
  height: 22vh;
  min-height: 150px;
  background-image: url('/login_bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.auth-hero-mobile::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(2, 6, 23, 0.7) 0%, rgba(2, 6, 23, 0.4) 100%);
}

.auth-hero-mobile__content {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-mobile__content {
  background: var(--va-background-secondary);
}
</style>
